import {Checkbox, Layout, Spacer, Text} from '@di-nxt/components';
import React, {useCallback} from 'react';

export type AvailabilityDayProps = {
  selected: boolean;
  title: string;
  value: number;
  onSelected: (day: number) => void;
};
export const AvailabilityDay: React.FC<AvailabilityDayProps> = ({
  selected,
  title,
  value,
  onSelected,
}) => {
  const handleSelected = useCallback(() => {
    onSelected(value);
  }, [onSelected, value]);
  return (
    <Layout paddingHorizontal="24" paddingTop="8" vertical>
      <Layout centered>
        <Checkbox
          kind="Default"
          state={selected ? 'Checked' : 'NotChecked'}
          onPress={handleSelected}
        />
      </Layout>
      <Spacer height="10" />
      <Layout centered>
        <Text variant="inline_14_default">{title}</Text>
      </Layout>
    </Layout>
  );
};
